// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariables.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var PagingModel = require('share/components/controls/DataGrid/helpers/Izenda.PagingModel');
  var constant = require('logic/data/Izenda.ReportSubscriptionConstants').SYSTEM_VARIABLES;
  var DEFAULT_VALUE = constant.DEFAULT_VALUE;
  var { forEach } = require('lodash/fp');
  var SystemVariable = require('logic/models/Izenda.SystemVariable');

  function SystemVariables() {
    var props = {
      pageInfo: new PagingModel(DEFAULT_VALUE.SORT_DIRS, null),
      variables: []
    };

    m.extendObservable(this, props);
  }

  /**
   * Populate data (Almost for fetching data from service).
   * @param  {object} data
   */
  SystemVariables.prototype.populateData = m.action(function(data) {
    data = data || {};
    this.variables.clear();

    forEach(
      function(item) {
        this.variables.push(new SystemVariable(item));
      }.bind(this),
      data.result
    );

    this.pageInfo.totalRecords = data.total;
    return Promise.resolve(true);
  });

  /**
   * Reset page model
   */
  SystemVariables.prototype.resetPageModel = m.action(function() {
    this.pageInfo = new PagingModel(DEFAULT_VALUE.SORT_DIRS, null);
    this.variables.clear();
  });

  module.exports = SystemVariables;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.SystemVariables.js